/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupDto } from './GroupDto';
import {
    GroupDtoFromJSON,
    GroupDtoFromJSONTyped,
    GroupDtoToJSON,
    GroupDtoToJSONTyped,
} from './GroupDto';
import type { ControlDto } from './ControlDto';
import {
    ControlDtoFromJSON,
    ControlDtoFromJSONTyped,
    ControlDtoToJSON,
    ControlDtoToJSONTyped,
} from './ControlDto';

/**
 * 
 * @export
 * @interface CatalogDto
 */
export interface CatalogDto {
    /**
     * 
     * @type {string}
     * @memberof CatalogDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDto
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDto
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDto
     */
    oscalVersion?: string;
    /**
     * 
     * @type {Date}
     * @memberof CatalogDto
     */
    lastModified?: Date;
    /**
     * 
     * @type {string}
     * @memberof CatalogDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogDto
     */
    documentId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CatalogDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CatalogDto
     */
    updated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogDto
     */
    hasGroups?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogDto
     */
    groupCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogDto
     */
    hasControls?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogDto
     */
    controlCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogDto
     */
    hasProperties?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogDto
     */
    propertiesCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogDto
     */
    hasLinks?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogDto
     */
    linkCount?: number;
    /**
     * 
     * @type {Array<GroupDto>}
     * @memberof CatalogDto
     */
    groups?: Array<GroupDto>;
    /**
     * 
     * @type {Array<ControlDto>}
     * @memberof CatalogDto
     */
    controls?: Array<ControlDto>;
}

/**
 * Check if a given object implements the CatalogDto interface.
 */
export function instanceOfCatalogDto(value: object): value is CatalogDto {
    return true;
}

export function CatalogDtoFromJSON(json: any): CatalogDto {
    return CatalogDtoFromJSONTyped(json, false);
}

export function CatalogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'version': json['version'] == null ? undefined : json['version'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'description': json['description'] == null ? undefined : json['description'],
        'documentId': json['documentId'] == null ? undefined : json['documentId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'hasGroups': json['hasGroups'] == null ? undefined : json['hasGroups'],
        'groupCount': json['groupCount'] == null ? undefined : json['groupCount'],
        'hasControls': json['hasControls'] == null ? undefined : json['hasControls'],
        'controlCount': json['controlCount'] == null ? undefined : json['controlCount'],
        'hasProperties': json['hasProperties'] == null ? undefined : json['hasProperties'],
        'propertiesCount': json['propertiesCount'] == null ? undefined : json['propertiesCount'],
        'hasLinks': json['hasLinks'] == null ? undefined : json['hasLinks'],
        'linkCount': json['linkCount'] == null ? undefined : json['linkCount'],
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(GroupDtoFromJSON)),
        'controls': json['controls'] == null ? undefined : ((json['controls'] as Array<any>).map(ControlDtoFromJSON)),
    };
}

export function CatalogDtoToJSON(json: any): CatalogDto {
    return CatalogDtoToJSONTyped(json, false);
}

export function CatalogDtoToJSONTyped(value?: CatalogDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'version': value['version'],
        'oscalVersion': value['oscalVersion'],
        'lastModified': value['lastModified'] == null ? undefined : ((value['lastModified']).toISOString()),
        'description': value['description'],
        'documentId': value['documentId'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'hasGroups': value['hasGroups'],
        'groupCount': value['groupCount'],
        'hasControls': value['hasControls'],
        'controlCount': value['controlCount'],
        'hasProperties': value['hasProperties'],
        'propertiesCount': value['propertiesCount'],
        'hasLinks': value['hasLinks'],
        'linkCount': value['linkCount'],
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(GroupDtoToJSON)),
        'controls': value['controls'] == null ? undefined : ((value['controls'] as Array<any>).map(ControlDtoToJSON)),
    };
}

